<template>
  <div>
    <label
      v-if="!formElement.hideLabel"
      :for="formElement.name"
      class="d-block"
    >
      {{ formElement.label }}
      <span v-if="formElement.required" class="text-danger">*</span></label
    >
    <div class="input-group">
      <b-form-input
        :id="formElement.name"
        :value="value"
        :max="formElement.maxLength"
        :maxlength="formElement.maxLength"
        :disabled="formElement.disabled"
        :type="type"
        :required="formElement.required"
        @input="$emit('input', $event)"
      ></b-form-input>
      <div class="input-group-append">
        <button
          class="btn btn-secondary"
          @mousedown="type = 'text'"
          @mouseup="type = 'password'"
        >
          <i class="fas fa-eye"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FormElementPassword",
  props: {
    formElement: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      type: "password",
    };
  },
};
</script>
